import React from 'react'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import { dispatch } from 'store'
import { actionTypes } from 'config'

const MemberAddressCard = ({member}) => {

	const { firstName, lastName, city, street, email, phone, mobile, car } = member.profile

	const handleOpenMember = async () => {

		dispatch({type: actionTypes.MEMBER.isOpen})
		const _member = { ...member }
		if(member.contactPerson) {
		  const contactPersonSnap = await member.contactPerson.get()
		  _member.contactPerson = contactPersonSnap.data()
		} else {
		  delete _member.contactPerson
		}
		if(member.bankAccount) {
		  const bankAccountSnap = await member.bankAccount.get()
		  _member.bankAccount = bankAccountSnap.data()
		} else {
		  delete _member.bankAccount
		}
		return dispatch({type: actionTypes.MEMBER.edit, payload: _member})
	}
	return (
		<Paper style={{padding: '0.5rem', color: 'white', backgroundColor: ''}}>
			<ul>
				<li>{`${lastName} ${firstName}`}</li>
				<li>{city}</li>
				<li>{street}</li>
				<li>{phone || 'Nicht vorhanden'}</li>
				<li>{mobile || 'Nicht vorhanden'}</li>
				<li>{email ? <a href={`mailto:${email}`} >{email}</a> : 'Nicht vorhanden'}</li>
				<li>Kfz: {car ? 'JA' : 'NEIN'}</li>
			</ul>
			<Button fullWidth size='small' variant='contained' onClick={handleOpenMember} >
				Mitglied öffnen
			</Button>
		</Paper>
	)
}

export default MemberAddressCard